<form  novalidate>   
    <section class="content">

        <div class="row">
            <!-- /.box -->
            <div class="box  box-primary">
                <PageHeader  [title]="title"  [showNote]="false" [showAddNew]="false" [showSearch]="false"
                        [showSave]="blnshowSave" (SaveEvent)="saveCategory()" [mainlisturl]="ListURL"
                      #pageheader></PageHeader>
                <div class="box">
                    <div class="box-body">
                        <div class="row ">

                            <div class="box ibox box-info">
                                <div class="col-sm-12 box-row"></div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="box ibox box-info">
                                <div class="clearfix"></div>
                                <div class="col-sm-12 box-row">
                                    <label class="col-sm-2 control-label">
                                        <span class="text-red inputrequired">*</span>Document Category:
                                    </label>
                                    <div class="col-sm-10">
                                      <input type="text" class="form-control mdInput"
                                        maxlength="50" [(ngModel)]="documentCategoryName" name="documentCategoryName" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                          <PageHeader [menuMode]="true"  [showNote]="false" [showAddNew]="false" [showSearch]="false"
                            [showSave]="blnshowSave" (SaveEvent)="saveCategory()" [mainlisturl]="ListURL"
                      #pageheader></PageHeader>
                    </div>
                </div>
               
            </div>
        </div>

    </section>
</form>